import './ImpersonatorNotice.scss';
import { adminActions } from '@sonar-software/sonar-admin';
import { createAsyncSelectors } from '@lib/selectors';
import { useNavigate } from 'react-router';
import { Alert, Button, Flex } from 'antd';
import { BASE_ROUTES, COPY_SPECIFIC, QUERY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect, useState } from 'react';
import { useAction, useAuthToken, useSonarSelector } from '../hooks';
const impersonateStopSelectors = createAsyncSelectors((state) => state.admin.authentication.impersonateStop.get);
export const ImpersonatorNotice = () => {
    const [search, setSearch] = useState('');
    const navigate = useNavigate();
    const { isImpersonator, impersonatorShard } = useAuthToken();
    const impersonateStopToken = useSonarSelector(impersonateStopSelectors.data);
    const getImpersonateStop = useAction(adminActions.requestGetAdminAuthenticationImpersonateStop);
    const handleOnExit = useCallback(() => {
        getImpersonateStop({ shardName: impersonatorShard });
    }, [getImpersonateStop, impersonatorShard]);
    const handleOnSwitch = useCallback(() => {
        setSearch(`?${QUERY.TARGET_ROUTE}=${BASE_ROUTES.ADMIN}`);
        handleOnExit();
    }, [handleOnExit]);
    useEffect(() => {
        if (impersonateStopToken) {
            navigate({
                pathname: `/token/${impersonateStopToken.token}`,
                search
            }, { replace: true });
        }
    }, [impersonateStopToken, navigate, search]);
    if (!isImpersonator) {
        return null;
    }
    return (React.createElement(Alert, { action: React.createElement(Flex, { gap: 4 },
            React.createElement(Button, { danger: true, onClick: handleOnSwitch, size: 'small' }, COPY_SPECIFIC.SWITCH),
            React.createElement(Button, { danger: true, onClick: handleOnExit, size: 'small' }, COPY_SPECIFIC.EXIT)), className: 'impersonator-notice', message: COPY_SPECIFIC.ADMIN_IMPERSONATOR_MODE, showIcon: true, type: 'error' }));
};
